import { IconDictionary } from "../Icon";
import { TextSizes } from "../Text";

export type TagType = {
  text: string;
  icon?: IconDictionary;
  textProps?: {
    size?: TextSizes;
    paragraph?: boolean;
    bold?: boolean;
  };
};
